"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useBulkMutation_1 = require("./useBulkMutation");
Object.defineProperty(exports, "useBulkMutation", { enumerable: true, get: function () { return useBulkMutation_1.default; } });
//# sourceMappingURL=index.js.map